export interface ApprovalLike { action_type?: string; risk?: string; status?: string; payload?: unknown }
export interface ApprovalDescription { title: string; lines: string[] }

const RISK_HR: Record<string, string> = { medium: "srednji", high: "visok", critical: "kritičan" };

function usd(value: unknown): string | null {
  if (typeof value !== "number" || !Number.isFinite(value) || value < 0) return null;
  return `${(value / 1_000_000).toFixed(2).replace(".", ",")} USD`;
}

function plainObject(value: unknown): Record<string, unknown> {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return {};
  return new Proxy(value as Record<string, unknown>, {
    get(target, prop) {
      try {
        return Reflect.get(target, prop);
      } catch {
        return undefined;
      }
    },
  });
}

export function approvalLabel(actionType: string | undefined): string {
  if (!actionType) return "Odobrenje";
  return actionType === "budget.limit_increase" ? "Odobrenje: mjesečni budžet" : `Odobrenje: ${actionType}`;
}

export function describeApproval(approval: ApprovalLike): ApprovalDescription {
  const source = plainObject(approval);
  const data = plainObject(source.payload);
  const actionType = typeof source.action_type === "string" ? source.action_type : undefined;

  if (actionType === "budget.limit_increase") {
    const period = typeof data.period === "string" ? data.period : "";
    const title = period ? `Odobriti mjesečni budžet za ${period}` : "Odobriti mjesečni budžet";

    const hard = data.hard_limit_micros;
    let hardLine: string;
    if (hard === null) hardLine = "Tvrdi limit: bez ograničenja";
    else {
      const hardUsd = usd(hard);
      hardLine = hardUsd !== null ? `Tvrdi limit: ${hardUsd}` : "Tvrdi limit: nije određen";
    }

    const softUsd = usd(data.soft_limit_micros);
    const softLine = softUsd !== null ? `Upozorenje na: ${softUsd}` : "Upozorenje na: nije određeno";

    return {
      title,
      lines: [hardLine, softLine, "Dok ne odlučite, tok čeka i ništa se ne troši."],
    };
  }

  const risk = typeof source.risk === "string" ? source.risk : undefined;
  return {
    title: `Odobrenje: ${actionType ?? "nepoznata radnja"}`,
    lines: [`Rizik: ${RISK_HR[risk ?? ""] ?? risk ?? "nepoznat"}`],
  };
}
